<template>
  <div v-show="filterItems && filterItems.length">
    <div v-if="collapsible" class="collaps">
      <sprcol :collapsedByDefault="isCollapsed" :heading="label" :fontsize="'15px !important;'">
        <div slot="body">
          <span v-for="(filteritem) in filterItems" :key="filteritem.name">
            <span :class="{ 'filterbutton': true, 'selected': isSelected(filteritem.id) }">
              <sprbutton
                :title="filteritem.name"
                :size="6"
                :bordersize="2"
                :value="filteritem.id.toString()"
                :class="status ? getStateFilterCssClass(filteritem.id) : ''"
                click-event="changeFilterItem"
                @changeFilterItem="changeFilterItem"
              />
            </span>
          </span>
        </div>
      </sprcol>
    </div>
    <div v-else class="row">
      <div class="col-12">
        <div class="cap-label">
          {{ label }}
        </div>
      </div>
    </div>
    <div v-if="!collapsible" class="row filter-customer-status">
      <div class="col-12">
        <span v-for="(filteritem) in filterItems" :key="filteritem.name">
          <span :class="{ 'filterbutton': true, 'selected': isSelected(filteritem.id) }">
            <sprbutton
              :title="filteritem.name"
              :size="6"
              :bordersize="2"
              :value="filteritem.id.toString()"
              :class="status ? getStateFilterCssClass(filteritem.id) : ''"
              click-event="changeFilterItem"
              @changeFilterItem="changeFilterItem"
            />
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue'
  import * as _ from 'lodash'
  import sprbutton from './SPRButton.vue'
  import sprcol from './SPRCollapsible.vue'

  export default Vue.extend({
    name: 'FilterButtonGroup',
    components: { sprbutton, sprcol },
    props: {
      filterItems: {
        type: Array as () => Array<any>,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      list: {
        type: Array as () => Array<any>,
        required: true
      },
      status: {
        type: Boolean,
        default: false
      },
      collapsible: {
        type: Boolean,
        default: false
      },
      isCollapsed: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      isSelected (id): boolean {
        return _.indexOf(this.list, id) >= 0
      },
      getStateFilterCssClass (id) {
        return `statefilteritem filteritem-${id}`
      },
      changeFilterItem (id) {
        this.$emit('update-list', id)
      }
    }
  })
</script>

<style lang="scss" scoped>
 @import "../assets/scss/_variables.scss";

    .filter-customer-type,
    .filter-customer-status,
    .filter-activity-type {
      margin-bottom: 30px;
    }
    .collaps {
      padding-bottom: 30px;
    }
    .cap-label {
      margin-bottom: 15px;
    }

    .filterbutton {
      padding-right:6px;
      margin-top:8px;
      display: inline-block;

      .statefilteritem {
        &:hover {
          color: $brand-white;
        }
        &.filteritem-1 {
          border-color: $state-pendingapproval;
          &:hover {
            background-color: $state-pendingapproval;
          }
        }

        &.filteritem-2 {
          border-color: $state-active;
          &:hover {
            background-color: $state-active;
          }
        }

        &.filteritem-3 {
          border-color: $state-pendingfriend;
          &:hover {
            background-color: $state-pendingfriend;
          }
        }

        &.filteritem-4 {
          border-color: $state-activefriendship;
          &:hover {
            background-color: $state-activefriendship;
          }
        }

        &.filteritem-5 {
          border-color: $state-nonactive;
          &:hover {
            background-color: $state-nonactive;
          }
        }

        &.filteritem-6 {
          border-color: $state-onhold;
          &:hover {
            background-color: $state-onhold;
          }
        }
      }

      button {
        border-color:$brand-grey5;
        color:$brand-black;
        font-size:12px;
        padding:5px 10px;

        &:hover {
          border-color:$brand-red;
          color:$brand-white;
        }

        &:focus {
          outline: none;
        }
      }

      &.selected {
        outline: none;
        button {
          outline: none;
          border-color:$brand-red;
          color:$brand-white;
          background-color:$brand-red;

          &:hover {
            color:$brand-white;
          }

          &.filteritem-1 {
            background-color: $state-pendingapproval;
          }
          &.filteritem-2 {
            background-color: $state-active;
          }
          &.filteritem-3 {
            background-color: $state-pendingfriend;
          }
          &.filteritem-4 {
            background-color: $state-activefriendship;
          }
          &.filteritem-5 {
            background-color: $state-nonactive;
          }
          &.filteritem-6 {
            background-color: $state-onhold;
          }
        }
      }
    }
</style>